import { Day } from "../../enums";
import { CommandLang } from "../../enums/command";
import { ORGANIZATION_COUNTRY_MAP, OrganizationCountry } from "../enums/country";
import { AuIsoLocale, AuLocales, CadIsoLocale, CadLocales, DeIsoLocale, DeLocales, GbIsoLocale, GbLocales, IeIsoLocale, IeLocales, Locales, UsaIsoLocale, UsaLocales, } from "../enums/locales";
export const getLocalesFromIsoLocale = (isoLocale) => {
    if (isoLocale?.toLowerCase()?.includes("fr")) {
        return Locales.FR;
    }
    if (isoLocale?.toLowerCase()?.includes("es")) {
        return Locales.ES;
    }
    if (isoLocale?.toLowerCase()?.startsWith("de")) {
        return Locales.DE;
    }
    if (isoLocale?.toLowerCase()?.includes("en")) {
        return Locales.EN;
    }
    return Locales.EN;
};
export const buildLocaleRecord = (record) => record;
export const buildUntranslatedUserMessage = (text) => ({
    [Locales.EN]: text,
    [Locales.FR]: text,
});
export const getUserMessageForLocale = (userMessage, locale) => userMessage[locale === Locales.FR ? Locales.FR : Locales.EN];
export const getIsoLocaleFromCountry = (country, storedLocale) => {
    if (country === OrganizationCountry.Canada) {
        return storedLocale === Locales.FR ? CadIsoLocale.FR : CadIsoLocale.EN;
    }
    if (country === OrganizationCountry.UnitedStates) {
        return storedLocale === Locales.ES ? UsaIsoLocale.ES : UsaIsoLocale.EN;
    }
    if (country === OrganizationCountry.GreatBritain) {
        return GbIsoLocale.EN;
    }
    if (country === OrganizationCountry.Australia) {
        return AuIsoLocale.EN;
    }
    if (country === OrganizationCountry.Ireland) {
        return IeIsoLocale.EN;
    }
    if (country === OrganizationCountry.Germany) {
        return storedLocale === Locales.EN ? DeIsoLocale.EN : DeIsoLocale.DE;
    }
    return storedLocale === Locales.FR ? CadIsoLocale.FR : CadIsoLocale.EN;
};
export const getLocaleFromCountry = (country, storedLocale) => {
    if (country === OrganizationCountry.Canada) {
        return CadLocales[storedLocale] || CadLocales.FR;
    }
    if (country === OrganizationCountry.UnitedStates) {
        return UsaLocales[storedLocale] || UsaLocales.EN;
    }
    if (country === OrganizationCountry.GreatBritain) {
        return GbLocales[storedLocale] || GbLocales.EN;
    }
    if (country === OrganizationCountry.Australia) {
        return AuLocales[storedLocale] || AuLocales.EN;
    }
    if (country === OrganizationCountry.Ireland) {
        return IeLocales[storedLocale] || IeLocales.EN;
    }
    if (country === OrganizationCountry.Germany) {
        return DeLocales[storedLocale] || DeLocales.DE;
    }
    return storedLocale;
};
export const resolveEmailLocale = (lang, country) => {
    if (!country) {
        return lang.toLowerCase();
    }
    return `${lang.toLowerCase()}-${ORGANIZATION_COUNTRY_MAP[country].countryCode}`;
};
export const resolveUntranslatedSpanishEmailLocale = (lang) => lang === Locales.ES ? Locales.EN : lang;
export const convertDayToLocale = (day, locale) => {
    const dayTranslationFr = {
        [Day.Monday]: "lundi",
        [Day.Tuesday]: "mardi",
        [Day.Wednesday]: "mercredi",
        [Day.Thursday]: "jeudi",
        [Day.Friday]: "vendredi",
        [Day.Saturday]: "samedi",
        [Day.Sunday]: "dimanche",
    };
    const dayTranslationDe = {
        [Day.Monday]: "Montag",
        [Day.Tuesday]: "Dienstag",
        [Day.Wednesday]: "Mittwoch",
        [Day.Thursday]: "Donnerstag",
        [Day.Friday]: "Freitag",
        [Day.Saturday]: "Samstag",
        [Day.Sunday]: "Sonntag",
    };
    if (locale === Locales.FR) {
        return dayTranslationFr[day];
    }
    if (locale === Locales.DE) {
        return dayTranslationDe[day];
    }
    return day;
};
export const getLanguageLabel = (locale) => {
    switch (locale) {
        case Locales.FR:
            return "french";
        case Locales.ES:
            return "spanish";
        case Locales.DE:
            return "german";
        default:
            return "english";
    }
};
export const getLocalesByCountry = (country) => {
    switch (country) {
        case OrganizationCountry.Canada:
            return [Locales.FR, Locales.EN];
        case OrganizationCountry.UnitedStates:
            return [Locales.EN, Locales.ES];
        case OrganizationCountry.Germany:
            return [Locales.DE];
        case OrganizationCountry.GreatBritain:
        case OrganizationCountry.Australia:
        case OrganizationCountry.NewZealand:
        case OrganizationCountry.Ireland:
            return [Locales.EN];
        default:
            return [Locales.EN];
    }
};
export const hasMultipleLocales = (country) => {
    return getLocalesByCountry(country).length > 1;
};
export const getAllowedDashboardLanguages = (country) => {
    if (country === OrganizationCountry.Canada) {
        return [Locales.FR, Locales.EN];
    }
    if (country === OrganizationCountry.Germany) {
        return [Locales.DE, Locales.EN];
    }
    return [Locales.EN];
};
export const getDashboardLocaleFromCountry = (country, requestedLocale) => {
    const allowedLanguages = getAllowedDashboardLanguages(country);
    if (allowedLanguages.includes(requestedLocale)) {
        return requestedLocale;
    }
    return allowedLanguages.includes(Locales.EN) ? Locales.EN : allowedLanguages[0];
};
export const getIsoLocale = (locale) => {
    switch (locale) {
        case "en":
            return UsaIsoLocale.EN;
        case "en-US":
            return UsaIsoLocale.EN;
        case "en-CA":
            return CadIsoLocale.EN;
        case "es":
            return UsaIsoLocale.ES;
        case "es-US":
            return UsaIsoLocale.ES;
        case "fr":
            return CadIsoLocale.FR;
        case "fr-CA":
            return CadIsoLocale.FR;
        case "en-GB":
            return GbIsoLocale.EN;
        case "en-AU":
            return AuIsoLocale.EN;
        case "en-IE":
            return IeIsoLocale.EN;
        case "de":
            return DeIsoLocale.DE;
        case "de-DE":
            return DeIsoLocale.DE;
        case "en-DE":
            return DeIsoLocale.EN;
        default:
            throw new Error(`Unsupported locale: ${locale}`);
    }
};
export const getIsoLocaleFromLocale = (locale) => {
    if (locale === Locales.FR) {
        return CadIsoLocale.FR;
    }
    else if (locale === Locales.ES) {
        return UsaIsoLocale.ES;
    }
    else if (locale === Locales.DE) {
        return DeIsoLocale.DE;
    }
    else {
        return UsaIsoLocale.EN;
    }
};
export const convertToCommandLang = (locale) => {
    if (locale === Locales.FR) {
        return CommandLang.FR;
    }
    if (locale === Locales.ES) {
        return CommandLang.ES;
    }
    if (locale === Locales.DE) {
        return CommandLang.DE;
    }
    return CommandLang.EN;
};
export const normalizeUserStoredLocale = (locale) => {
    return locale === Locales.ES ? Locales.EN : locale;
};
export const getLocaleLabelTranslationKey = (locale) => {
    if (locale === Locales.FR) {
        return "common.French";
    }
    if (locale === Locales.ES) {
        return "common.Spanish";
    }
    if (locale === Locales.DE) {
        return "common.German";
    }
    return "common.English";
};
export const getLocaleRedirectionFromCloudflareHeader = (countryByCloudflareHeader, isoLocale, locale) => {
    if (countryByCloudflareHeader === "United States" && !isoLocale.includes("US")) {
        return UsaIsoLocale.EN;
    }
    if (countryByCloudflareHeader === "Canada" && !isoLocale.includes("CA")) {
        return locale === Locales.EN ? CadIsoLocale.EN : CadIsoLocale.FR;
    }
    if (countryByCloudflareHeader === "United Kingdom" && !isoLocale.includes("GB")) {
        return GbIsoLocale.EN;
    }
    if (countryByCloudflareHeader === "Australia" && !isoLocale.includes("AU")) {
        return AuIsoLocale.EN;
    }
    if (countryByCloudflareHeader === "Ireland" && !isoLocale.includes("IE")) {
        return IeIsoLocale.EN;
    }
    if (countryByCloudflareHeader === "Germany" && !isoLocale.includes("DE")) {
        return DeIsoLocale.DE;
    }
};
export const getIsoLocaleFromBrowserLanguage = (browserLanguage) => {
    if (browserLanguage.startsWith("fr")) {
        return CadIsoLocale.FR;
    }
    else if (browserLanguage.startsWith("es")) {
        return UsaIsoLocale.ES;
    }
    else if (browserLanguage.startsWith("de")) {
        return DeIsoLocale.DE;
    }
    else if (browserLanguage.startsWith("en-AU")) {
        return AuIsoLocale.EN;
    }
    else if (browserLanguage.startsWith("en-GB")) {
        return GbIsoLocale.EN;
    }
    else if (browserLanguage.startsWith("en-IE")) {
        return IeIsoLocale.EN;
    }
    else if (browserLanguage.toLowerCase().startsWith("en-de")) {
        return DeIsoLocale.EN;
    }
    else if (browserLanguage.startsWith("en")) {
        return UsaIsoLocale.EN;
    }
    else {
        return UsaIsoLocale.EN; // default
    }
};
export const getCountryFromAcceptLanguage = (acceptLanguage) => {
    if (acceptLanguage.includes("fr-CA") || acceptLanguage.includes("en-CA")) {
        return OrganizationCountry.Canada;
    }
    if (acceptLanguage.includes("en-GB")) {
        return OrganizationCountry.GreatBritain;
    }
    if (acceptLanguage.includes("en-AU")) {
        return OrganizationCountry.Australia;
    }
    if (acceptLanguage.includes("en-IE")) {
        return OrganizationCountry.Ireland;
    }
    if (acceptLanguage.includes("de-DE") || acceptLanguage.includes("en-DE")) {
        return OrganizationCountry.Germany;
    }
    return undefined;
};
export const cleanPathFromLocale = (path) => {
    return path.replace(/^\/(en-CA|en-US|fr-CA|en-ES|de-DE|en-DE)\//, "/");
};
export const WYSIWYG_EDITOR_LANGUAGE = {
    [Locales.EN]: undefined,
    [Locales.FR]: "fr",
    [Locales.ES]: "es",
    [Locales.DE]: "de",
};
